import { useEffect } from "react";
import ProtectedRoute from "../components/ProtectedRoute";
import Profile from "../components/profile"; 
import Cookies from "js-cookie";

export default function Home() {


  const userCookie = Cookies.get('auth_user');
  let user;

  useEffect(() => {
    if (userCookie) {
      try {
        user = JSON.parse(userCookie);
        document.title = "Bienvenue-" + user.name;
      } catch (error) {
        console.error('Erreur de parsing JSON:', error);
      }
    }
    
    
  }, []);

  return (
    <ProtectedRoute>
      <Profile/>  
    </ProtectedRoute> 

  )
}